import HubPaginationProvider from './HubPaginationProvider.js';

export default class extends HubPaginationProvider {

  buildKey(route) {
    if (!_.isObject(route) || !route) {
      return null;
    }

    if (_.has(route, 'meta.paginationGroupName')) {
      return route.meta.paginationGroupName;
    }

    if ('name' in route) {
      return route.name;
    }

    if ('fullPath' in route) {
      return route.fullPath;
    }

    return null;
  }


  getPerPage(route) {
    return super.getPerPage(this.buildKey(route));
  }


  setPerPage(route, value) {
    super.setPerPage(this.buildKey(route), value);
  }
}
